<script>
import { openNotificationWithIcon, findPane } from '@/utils/util'
import { docDetail } from '@/api/login'
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'ErpHeaderMenu',
  data () {
    return {
      documentId: [],
      catalogId: []
    }
  },
  props: {
    myMenus: {
    },
    theme: {
      type: String,
      default: 'light'
    },
    mode: {
      type: String,
      default: 'vertical'
    }
  },
  computed: {
    ...mapGetters(['menus']),
    ...mapState({
      'DocCenterMeunIsLoading': state => state.isLogin.DocCenterMeunIsLoading
    })
  },
  watch: {
    menus: {
      handler: function (val) {
        const { docId, catId } = this.$route.query
        if (!val?.length) return
        if (!docId && !catId) {
          this.$nextTick(() => {
            this.firstShow(val)
          })
        } else if (!catId && docId) {
          const found = findPane(val, { documentId: docId * 1 }, {}, ['documentId', 'catalogId'], ['documentDTOList', 'childCatalog'])
          if (!found) return
          this.catalogId = found.deep === 2 ? [`0-${found.catalogId}-${found.catalogId}`, `0-${found.parent.parentId}`] : [`0-${found.catalogId}`]
        }
      },
      immediate: true
    },
    documentId: 'documentIdChange'
  },
  mounted () {
    const { docId, catId } = this.$route.query
    if (docId) {
      this.documentId = [docId]
    }
    if (catId) {
      if (catId.indexOf(',') !== -1) {
        this.catalogId = catId.split(',')
      } else {
        this.catalogId = [catId]
      }
    }
  },
  methods: {
    firstShow (myMenus) {
      if (myMenus && myMenus.length) {
        let first = this.findFirstMenuItem(myMenus[0])
        this.documentId = [first.documentId + '']
        this.catalogId = this.findFirstgetOpenKeys(myMenus[0]).concat(this.findSecondgetOpenKeys(myMenus[1]))
        console.log('???', this.catalogId)
      }
    },
    findFirstMenuItem (source, found) {
      if (source.childCatalog instanceof Array && source.childCatalog.length > 0) {
        found = this.findFirstMenuItem(source.childCatalog[0])
      } else {
        found = source.documentDTOList[0]
      }
      return found
    },
    findFirstgetOpenKeys (source, found) {
      let arr = []
      source.level === 1 && arr.push(`0-${source.catalogId}`)
      if (source.childCatalog instanceof Array && source.childCatalog.length > 0) {
        found = this.findFirstgetOpenKeys(source.childCatalog[0])
        if (source.childCatalog instanceof Array !== Array) {
          let Index = '0'
          for (let i = 0; i < source.childCatalog[0].level; i++) {
            Index = Index.concat(`-${source.childCatalog[0].catalogId}`)
          }
          arr.push(Index) // ['0-194', '0-195-195']
        }
      }
      return arr
    },
    findSecondgetOpenKeys (source, found) {
      let arr = []
      source.level === 1 && arr.push(`0-${source.catalogId}`)
      return arr
    },
    handleClick (e) {
      if (e.keyPath.length > 1) {
        this.documentId = [e.key]
        this.$store.dispatch('setActiveKey', e.key)
        let catId = [e.key]
        if (e.keyPath.length > 2) {
          catId = [e.keyPath[1], e.keyPath[2]]
        } else if (e.keyPath.length > 1) {
          catId = [e.keyPath[1]]
        }
        this.$router.push({
          path: '/documentCenter',
          query: {
            docId: e.key,
            catId: catId.join(',')
          }
        })
      } else { // 当没有子文档的时候
        openNotificationWithIcon('该目录暂无文档！')
      }
    },
    renderMenuItem (e, key = '0') {
      const { childCatalog, catalogId, catalogName, documentDTOList, documentId, title } = e

      let menus1 = []
      let menus2 = []

      if (childCatalog && childCatalog.length) {
        menus1 = childCatalog.map((menu) => {
          return this.renderMenuItem(menu, `${key}-${menu.catalogId}`)
        })
      }
      if (documentDTOList && documentDTOList.length) {
        menus2 = documentDTOList.map((menu) => {
          return this.renderMenuItem(menu, `${key}-${menu.documentId}`)
        })
      }
      if (menus1.length || menus2.length) {
        const menus = menus1.concat(menus2)
        return (
          <a-sub-menu key={`${key}-${catalogId}`} title={catalogName}>
            {menus}
          </a-sub-menu>
        )
      }
      if (documentId) { // 当最后一级
        return (
          <a-menu-item key={`${documentId}`}>{title}</a-menu-item>
        )
      } else {
        return (
          <a-sub-menu key={`${key}-${catalogId}`} title={catalogName}></a-sub-menu>
        )
      }
    },
    onchange (openKeys) {
      this.catalogId = openKeys
    },
    documentIdChange () {
      docDetail({
        documentId: (this.documentId instanceof Array) ? this.documentId[0] : this.documentId
      }).then((res) => {
        const { data } = res
        if (res.code === '200') {
          this.$store.commit('DOCDETAIL', data)
        } else {
          openNotificationWithIcon(res.message)
        }
      })
    }
  },
  render () {
    console.log('this.catalogId', this.catalogId)
    const {
      handleClick,
      $props: {
        myMenus,
        theme,
        mode
      }
    } = this
    const menuItems = myMenus.map(menu => this.renderMenuItem(menu))
    return (
      <div>
      {
        this.DocCenterMeunIsLoading
          ? (
            <div style='position: absolute;top: 34%;left: 36%;'>
              <a-spin tip='Loading...' spinning={this.DocCenterMeunIsLoading} size='large'/>
            </div>
          )
          : (
              <a-menu
                selected-keys={this.documentId}
                open-keys={this.catalogId}
                theme={theme}
                mode={mode}
                onopenChange={this.onchange}
                {...{ on: { click: handleClick } }}>
                {menuItems}
              </a-menu>
          )
      }
      </div>
    )
  }
}
</script>
